/**
 * One slug for a sport name everywhere ("Table Tennis" → "table_tennis").
 * ST-B04: PlayerSportStats compared "table tennis" with the key "table_tennis",
 * so table tennis career stats never rendered.
 */
export const toSlug = (name) =>
  String(name || '').toLowerCase().trim().replace(/[\s-]+/g, '_');

export default toSlug;
